<template>
  <div class="circle_list_box">
    <div v-for="(item, index) in list" :key="item.board_id" class="circle_item lf" :class="type === 'personalMy' || type === 'personalJoin' ? 'my_personal_circle_item' : ''">
      <div class="circle_item_left">
        <div class="circle_item_img" @click.stop="jump(item.board_id)">
          <img :src="item.pic" alt="">
        </div>
        <div v-if="type === 'my' || type === 'personalMy'" class="circle_item_btn">
          <button
          :class="myHoverIndex === index ? 'greenglga_btn greenglga_btn_cancle' : 'greenglga_btn greenglga_btn_confirm'"
          @mouseenter="myHoverIndex = index"
          @mouseleave="myHoverIndex = ''"
          @click="editBorad(item, index)">
            <span>修改</span>
          </button>
        </div>
        <div v-if="type === 'join' || type === 'personalJoin'" class="circle_item_btn">
          <button v-show="item.is_join === 0"
          class="greenglga_btn"
          @click="applyBoard(item.board_id, index)"
          >
            <i class="add">+</i>
            <span>加入</span>
          </button>
          <button v-show="item.is_join === 1"
          :class="joinHoverIndex === index ? 'greenglga_btn greenglga_btn_cancle' : 'greenglga_btn greenglga_btn_confirm'"
          @mouseenter="joinHoverIndex = index"
          @mouseleave="joinHoverIndex = ''"
          @click = "retreatBoard(item.board_id, index)">
            <span v-show="joinHoverIndex !== index">已加入</span>
            <span v-show="joinHoverIndex === index">退出</span>
          </button>
        </div>
        <div v-if="type === 'hot' || type === 'time'" class="circle_item_btn">
          <button v-show="item.is_join === 0"
          class="greenglga_btn"
          @click="applyBoard(item.board_id, index)"
          >
            <span>加入</span>
          </button>
          <button v-show="item.is_join === 1"
          :class="joinHoverIndex === index ? 'greenglga_btn greenglga_btn_cancle' : 'greenglga_btn greenglga_btn_confirm'"
          @mouseenter="joinHoverIndex = index"
          @mouseleave="joinHoverIndex = ''"
          @click = "retreatBoard(item.board_id, index)">
            <span v-show="joinHoverIndex !== index">已加入</span>
            <span v-show="joinHoverIndex === index">退出</span>
          </button>
        </div>
      </div>
      <div class="circle_item_right" @click.stop="jump(item.board_id)">
        <div class="circle_item_title">{{item.board_name}}</div>
        <div class="circle_item_info">
          <span>{{item.user_name}}</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{item.numbers}} 位成员</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{item.post_count}}个话题</span>
        </div>
        <div v-if="item.synopsis === ''" class="circle_item_text" @click.stop="jump(item.board_id)">
          暂无圈子简介
        </div>
        <div v-else class="circle_item_text" @click.stop="jump(item.board_id)">
          {{item.synopsis}}
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div v-if="type === 'my' || type === 'join' || type === 'hot' || type === 'time'" class="hr_page">
      <page-button :list = "list"
      :limit = "limit"
      @page = "page"
      ref="page"></page-button>
    </div>
  </div>
</template>

<script>
import page from '../Public/page.vue'
export default {
  components: {
    pageButton: page
  },
  props: {
    list: { required: true },
    type: { required: true },
    limit: { required: true }
  },
  data () {
    return {
      myHoverIndex: -1, // 我的圈子鼠标移入记录下标
      joinHoverIndex: -1, // 我加入的圈子鼠标移入记录下标
      newHoverIndex: -1 // 最新圈子鼠标移入记录下标
    }
  },
  methods: {
    // 圈子帖子列表跳转
    jump (rid) {
      const routeData = this.$router.resolve({
        path: '/cirlePostList/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 圈子列表 -- 加载更多
    page (num) {
      this.$emit('page', num, this.type)
    },
    // 圈子功能 - 修改圈子内容
    editBorad (data, index) {
      this.$emit('edit', data, index)
    },
    // 圈子功能 - 加入圈子
    applyBoard (id, index) {
      this.$emit('apply', id, index, this.type)
    },
    // 圈子功能 - 退出圈子
    retreatBoard (id, index) {
      this.$emit('retreat', id, index, this.type)
    }
  }
}
</script>

<style>
  .my_personal_circle_item.circle_item{
    width: 430px;
  }
</style>
